let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("63rje")).then(() => parcelRequire('85XJa'));